import Vuex from 'vuex';

/**
 * Wrapper on top of mapGetters function from Vuex module.
 * Enables "two-way" getters = binds getter and a mutation,
 * hence creates a property which is stored completely in the Vuex store
 * but can be treated as a property of the component it is bounded to.
 */
function mapGetters(params) {
  if (Array.isArray(params)) {
    return Vuex.mapGetters(params);
  }

  const oneWay = {};
  const twoWay = {};
  if (params instanceof Object) {
    Object.entries(params).forEach(([key, value]) => {
      if (typeof value === 'string') {
        oneWay[key] = value;
      } else {
        let get, set;

        if (Array.isArray(value)) {
          get = value[0];
          set = value[1];
        } else if (value instanceof Object) {
          get = value.get;
          set = value.set;
        } else {
          throw new Error(key + ' is in wrong format');
        }

        twoWay[key] = {
          get: function () {
            return this.$store.getters[get];
          },
          set: function (value) {
            return this.$store.commit(set, value);
          },
        };
      }
    });
  }

  return {
    ...Vuex.mapGetters(oneWay),
    ...twoWay,
  };
}

export default mapGetters;
